import { styled } from 'styled-components';

const FooterPartnerType = styled.div`
  color: #717171;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  font-size: 0.875rem;
`;
export { FooterPartnerType };
